import { Lock } from "@mui/icons-material";
import { Alert, AlertTitle, Box } from "@mui/material";

export default function PasswordRules() {
  return (
    <>
      <Alert severity="info" icon={<Lock />}>
        <AlertTitle>Create a Strong Password</AlertTitle>
        <Box>
          <strong>Your password must:</strong>
          <ul style={{ margin: "0.25rem 0", paddingLeft: "1rem" }}>
            <li>Be at least 14 characters long</li>
            <li>Use both UPPERCASE and lowercase letters</li>
            <li>Include at least one number or symbol (like @, #, or !)</li>
            <li>
              Not use your name or username (no more than 2 letters in a row)
            </li>
            <li>Be different from your old passwords</li>
          </ul>
        </Box>
      </Alert>
    </>
  );
}
